/// <amd-module name="Build/Admin/Pool/Stores/DownloadAgentDialogStore" />
import { Store } from "VSS/Reflux/Store";

export interface IDownloadAgentDialogStoreState {
    isOpen: boolean;
}

export class DownloadAgentDialogStore extends Store {
    public state: IDownloadAgentDialogStoreState;

    constructor() {
        super("DownloadAgentDialogStoreChanged");

        this.state = {
            isOpen: false
        };
    }

    public showDialog = () => {
        this.state = { 
            isOpen: true
        };
        this.emitChanged();
    }

    public dismissDialog = () => {
        this.state = {
            isOpen: false
        };
        this.emitChanged();
    }
}
